import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/dropdown-navigation';

import './style.scss';

// tslint:disable-next-line
register('stores-dropdown', () => import(/* webpackMode: "lazy" */'./stores-dropdown'));
